import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormatadorHelper } from '../../../helpers/formatador.helper';
import { DividendoHistoricoResponse, DividendoResponse } from '../../../models/dividendo.model';
import { ModoDistribuicaoBeneficiarioEnum } from '../../../models/enums/dividendo.enum';

@Component({
  selector: 'app-dividendos-detalhes',
  templateUrl: './dividendos-detalhes.component.html',
  styleUrls: ['./dividendos-detalhes.component.scss']
})
export class DividendosDetalhesComponent {
  @Input() visible = false;
  @Input() dividendo?: DividendoResponse;
  @Output() visibleChange = new EventEmitter<boolean>();

  get historicosOrdenados(): DividendoHistoricoResponse[] {
    return [...(this.dividendo?.historicos ?? [])]
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  }

  get isModoProporcional(): boolean {
    return this.dividendo?.modoDistribuicaoBeneficiario === ModoDistribuicaoBeneficiarioEnum.Proporcional;
  }

  fechar(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  formatarCpf(cpf?: string): string {
    if (!cpf) return '—';
    return FormatadorHelper.formatarCpfCnpj(cpf);
  }

  getStatusPagamentoSeverity(status: string): 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'contrast' | undefined {
    switch (status) {
      case 'Pago': return 'success';
      case 'Pendente': return 'warning';
      case 'Cancelado': return 'danger';
      default: return 'info';
    }
  }

  getStatusReinfClass(status: string): string {
    const normalizado = status?.toLowerCase() ?? '';
    if (normalizado.includes('não enviado') || normalizado.includes('nao enviado')) return 'status-reinf--nao-enviado';
    if (normalizado.includes('enviado')) return 'status-reinf--enviado';
    if (normalizado.includes('retific')) return 'status-reinf--retificado';
    if (normalizado.includes('erro')) return 'status-reinf--erro';
    if (normalizado.includes('exclu')) return 'status-reinf--excluido';
    return 'status-reinf--nao-enviado';
  }

  getHistoricoIcon(tipo: string): string {
    const normalizado = tipo?.toLowerCase() ?? '';
    if (normalizado.includes('retific')) return 'pi pi-refresh';
    if (normalizado.includes('cancel')) return 'pi pi-times';
    return 'pi pi-info-circle';
  }

  getHistoricoIconClass(tipo: string): string {
    const normalizado = tipo?.toLowerCase() ?? '';
    if (normalizado.includes('retific')) return 'historico-item__icon--retificacao';
    if (normalizado.includes('cancel')) return 'historico-item__icon--cancelamento';
    return 'historico-item__icon--default';
  }
}
